import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { OrganizationEntryPitchDto } from "../../../../autogen/bff-api";
import { OrganizationEntryModal } from "../../entry/view/OrganizationEntryModal";

interface Props {
  entries: OrganizationEntryPitchDto[];
}

export const LinkedEntries = ({ entries }: Props) => {
  const { t } = useTranslation();
  const [showEntryId, setShowEntryId] = useState<string>();

  return (
    <>
      {showEntryId && <OrganizationEntryModal entryId={showEntryId} onClose={() => setShowEntryId(undefined)} />}
      <Flex
        flexDirection="column"
        alignItems="start"
        justifyContent="start"
        borderRadius="lg"
        bg="smBackground"
        width="full"
        border="1px solid"
        borderColor="smBorder"
        p="6"
      >
        <Box width="full">
          <Text fontSize="md" fontWeight="bold">
            {t("Linked organization entries")}
          </Text>
          <Flex flexDirection="column" width="full">
            {entries.map((e) => (
              <Flex key={e.id} mt="2.5">
                <Button variant="link" colorScheme="blue" onClick={() => setShowEntryId(e.id)}>
                  {e.name}
                </Button>
              </Flex>
            ))}
          </Flex>
        </Box>
      </Flex>
    </>
  );
};
